import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Pin01 = function Pin01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12.0004 15v7m-4-14.6919v2.1307c0 .208 0 .312-.0204.4115a1 1 0 0 1-.089.2539c-.0463.0904-.1112.1716-.2412.3341L6.08 12.4005c-.6657.8322-.9986 1.2482-.999 1.5984a1 1 0 0 0 .3762.7826C5.7309 15 6.2637 15 7.3294 15h9.342c1.0657 0 1.5986 0 1.8723-.2185a1 1 0 0 0 .3761-.7826c-.0004-.3502-.3332-.7662-.999-1.5984l-1.5698-1.9622c-.1299-.1625-.1949-.2437-.2411-.3341a1 1 0 0 1-.0891-.254c-.0204-.0994-.0204-.2034-.0204-.4114V7.308c0-.115 0-.1727.0065-.2294a1 1 0 0 1 .0288-.1493c.015-.0552.0364-.1086.0792-.2155l1.0078-2.5197c.2941-.735.4411-1.1026.3798-1.3977a1 1 0 0 0-.4266-.63C16.8247 2 16.4289 2 15.6372 2H8.3637c-.7917 0-1.1876 0-1.4388.1665a1 1 0 0 0-.4265.63c-.0613.295.0857.6626.3797 1.3977L7.886 6.714c.0427.1069.0641.1603.0792.2155a1 1 0 0 1 .0287.1493c.0065.0567.0065.1143.0065.2294"
    })
  }));
};
export default Pin01;